import WatchPage from 'src/components/page/watch'
export default WatchPage